import { GfaLayerManagerV1Impl } from './gfa/gfa-layer-manager-v1-impl';
import { LayerManagerV1Impl } from './v1';
import { LayerManagerV2Impl, LayerManagerV2ImplProxy, } from './v2';
export * from './v1/types';
export * from './v2/types';
export const layerManagerDefinition = {
    id: 'layer-manager',
    dependencies: {
        featureServices: {
            's2:logger': '^1.0.0',
        },
    },
    create({ featureServices, }) {
        const layerManagerV2 = new LayerManagerV2Impl(featureServices['s2:logger'] || console);
        return {
            '1.2.0': () => {
                const layerManager = new LayerManagerV2ImplProxy(layerManagerV2);
                return {
                    featureService: new LayerManagerV1Impl(layerManager),
                    unbind: () => layerManager.unbind(),
                };
            },
            '2.7.2': () => {
                const layerManager = new LayerManagerV2ImplProxy(layerManagerV2);
                return {
                    featureService: layerManager,
                    unbind: () => layerManager.unbind(),
                };
            },
        };
    },
};
export const gfaLayerManagerDefinition = {
    id: 'gfa:layer-manager',
    dependencies: {
        featureServices: {
            'layer-manager': '^2.7.2',
        },
    },
    create: (env) => {
        const layerManager = new GfaLayerManagerV1Impl(env.featureServices['layer-manager']);
        return {
            '1.0.0': () => ({
                featureService: layerManager,
            }),
        };
    },
};
//# sourceMappingURL=index.js.map